export =[
    {
        "circle": {
            "fill": {
                "color": "rgba(197,37,84,0.2)",
                "gradient": ["rgba(197,37,84,0.2)", "rgba(197,37,84,0.8)"]
            },
            "opacity": 1,
            "stroke": {
                "color": "rgba(227,83,105,0.5)",
                "width": 4
            },
            "radius": 7
        }
    }
];